/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
import {gsap} from 'gsap';
( function( app ) {
  const COMPONENT = {
    init: function() {
      const elementAbove = document.querySelector( '.bio-box__details' );
      const elementBelow = document.querySelector( '.current-classes' );

      if ( elementAbove && elementBelow ) {
        const aboveRect = elementAbove.getBoundingClientRect();
        const belowRect = elementBelow.getBoundingClientRect();
        const distanceInPixels = belowRect.top - aboveRect.bottom;
        elementBelow.style.marginTop = `-${distanceInPixels - 96}px`;
      }

      $( '.navbar-toggle' ).on( 'toggleAfter', ( event ) => {
        $( '.primary-nav' ).slideToggle();
      } );

      $( '.js-init-video' ).magnificPopup( {
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
        callbacks: {
          open: function() {
            $( 'video' ).trigger( 'pause' );
          },
          close: function() {
            $( 'video' ).trigger( 'play' );
          },
        },
      } );

      if ( $( '.announcement-banner' ).length && !localStorage.getItem( 'lacHideAnnouncement' ) ) {
        $( '.announcement-banner' ).show();

        setTimeout( function() {
          $( '.announcement-banner' ).each( function( key, val ) {
            $( this ).addClass( 'is-loaded' );
            const headerHeight = $( 'header.navbar' ).outerHeight();
            const adminBarHeight = $( '#wpadminbar' ).outerHeight() || 0;
            const bodyHeight = $( '.main' ).outerHeight();

            const tl = gsap.timeline( {
              scrollTrigger: {
                trigger: this,
                pin: $( this ).find( '.banner-wrapper' )[0],
                start: 'top ' + ( headerHeight + adminBarHeight ),
                end: '+=' + ( bodyHeight - ( headerHeight + adminBarHeight + $( '.announcement-banner' ).outerHeight() ) ),
                pinSpacing: false,
                scrub: 0,
                // markers: true,
              },
            } );
          } );
        }, 1000 );
      } else {
        $( '.announcement-banner' ).remove();
      }

      $( '.announcement-banner .close' ).on( 'click', function() {
        $( '.announcement-banner' ).remove();
        localStorage.setItem( 'lacHideAnnouncement', true );
      } );

      function handleMobileChange( event ) {
        /*
         * Remove any inline display values when the screen changes
         * between mobile and desktop state. This allows the default
         * stylings to kick in and prevent any weird "half mobile half desktop"
         * nav display states that sometimes occur while resizing the browser
         * Also remove any active is-open classes from the toggle and nav to reset
         * its state when switching between screen sizes
         */
        if ( event.matches ) {
          if ( $( '.primary-nav' ).length > 0 ) {
            $( '.primary-nav' ).get( 0 ).style.removeProperty( 'display' );

            $( '.navbar-toggle, .primary-nav' ).removeClass( 'is-open' );
          }
        }
      }

      /* Run the handleMobileChange function when the screen sizes changes based on the mobileSize const */
      const mobileSize = window.matchMedia( '(min-width: 768px)' );
      handleMobileChange( mobileSize );
      mobileSize.addEventListener( 'change', handleMobileChange );

      /* Allow selects to have placeholder styles */
      checkSelectPlaceholder();
      $( '.gfield_select' ).on( 'change', function() {
        checkSelectPlaceholder();
      } );
      function checkSelectPlaceholder() {
        if ( $( '.gfield_select' ).find( 'option:selected' ).hasClass( 'gf_placeholder' ) ) {
          $( '.gfield_select' ).addClass( 'placeholder-selected' );
        } else {
          $( '.gfield_select' ).removeClass( 'placeholder-selected' );
        }
      }

      /* Lazyload all embeds */
      if ( 'IntersectionObserver' in window ) {
        const options = {
          root: null, // avoiding 'root' or setting it to 'null' sets it to default value: viewport
          rootMargin: '0px 0px 100px', // determines how far form the root the intersection callback will trigger
        };
        const embedObserver = new IntersectionObserver( function( entries, observer ) {
          entries.forEach( function( embed ) {
            if ( embed.isIntersecting ) {
              $( embed.target ).attr( 'src', $( embed.target ).attr( 'data-src-defer' ) );
              // remove observer
              embedObserver.unobserve( embed.target );
            }
          } );
        }, options );

        // add the observer to the elements
        $( '[data-src-defer]' ).each( function( index, element ) {
          embedObserver.observe( element );
        } );
      }

      function trackTab( lastItem, firstItem ) {
        $( document ).on( 'keydown', function( e ) {
          const keyCode = e.keyCode || e.which;

          if ( keyCode === 9 && !e.shiftKey ) {
            if ( document.activeElement === lastItem ) {
              e.preventDefault();
              focusedElement.focus();
            }
          }

          if ( keyCode === 9 && e.shiftKey ) {
            if ( document.activeElement === focusedElement ) {
              e.preventDefault();
              lastItem.focus();
            }
          }
        } );
      }

      $( '.a11y-skip-link' ).on( 'click', function( e ) {
        let wpadminBarHeight = 0;
        if ( $( '#wpadminbar' ).length > 0 ) {
          wpadminBarHeight = $( '#wpadminbar' ).outerHeight();
        }
        const headerHeight = $( 'header.navbar' ).outerHeight();

        $( 'html,body' ).animate( {
          scrollTop: $( '.main > *:first-child' ).offset().top - ( headerHeight + wpadminBarHeight ),
        }, 'slow' );
        $( '.main > *:first-child' ).attr( 'tabindex', '0' ).focus();
      } );

      document.addEventListener( 'keydown', function( e ) {
        if ( e.keyCode === 9 ) {
          $( 'body' ).addClass( 'a11y-is-tabbing' );
        }
      } );

      document.addEventListener( 'click', function( e ) {
        if ( e.target.localName !== 'a' && e.target.localName !== 'button' ) {
          $( 'body' ).removeClass( 'a11y-is-tabbing' );
        }
      } );

      $( '.navbar a, .navbar button' ).focus( function() {
        if ( $( this ).closest( '.dropdown-menu' ).length > 0 ) {
          const tabItems = $( this ).closest( '.dropdown-menu' ).find( 'a' );
          const itemKey = $.inArray( this, tabItems );

          document.onkeydown = function( e ) {
            switch ( e.which ) {
              case 38: // up
                $( tabItems[itemKey - 1] ).focus();
                break;
              case 40: // down
                $( tabItems[itemKey + 1] ).focus();
                break;

              default: return; // exit this handler for other keys
            }
            e.preventDefault();
          };
        } else {
          const tabItems = $( this ).closest( 'ul[role="menubar"]' ).find( '> li > a, > li > button' );
          const itemKey = $.inArray( this, tabItems );

          document.onkeydown = function( e ) {
            switch ( e.which ) {
              case 37: // left
                $( tabItems[itemKey - 1] ).focus();
                break;

              case 39: // right
                $( tabItems[itemKey + 1] ).focus();
                break;

              default: return; // exit this handler for other keys
            }
            e.preventDefault();
          };
        }
      } );

      let focusedElement;

      // Basic Collapse toggle for dropdowns and toggle menus
      $( '.dropdown-toggle' ).on( 'click', function( e ) {
        e.preventDefault();
        // if target element is not open already
        // find all open collapse elements and close them
        const target = $( this ).data( 'toggle-target' );
        focusedElement = document.activeElement;
        const tabItems = $( target ).find( 'a' );

        if ( !$( this ).is( '.is-open' ) ) {
          if ( $( 'body' ).hasClass( 'a11y-is-tabbing' ) ) {
            $( target ).find( 'li:first-child a' ).focus();
          }

          $( this ).attr( 'aria-expanded', true );
          $( target ).attr( 'aria-expanded', true ).attr( 'aria-hidden', false );

          const lastItem = tabItems[tabItems.length - 1];
          $( tabItems ).each( function( index, el ) {
            $( el ).attr( 'tabindex', '' );
            $( el ).attr( 'aria-hidden', 'false' );
          } );

          trackTab( lastItem, focusedElement );
        } else {
          $( this ).attr( 'aria-expanded', false );
          $( target ).attr( 'aria-expanded', false ).attr( 'aria-hidden', true );
          $( tabItems ).each( function( index, el ) {
            $( el ).attr( 'tabindex', -1 );
            $( el ).attr( 'aria-hidden', 'true' );
          } );
        }
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'common', COMPONENT );
} )( app );
